<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="dialogLabel"
    width="810px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content add-warehouse-charge-dialog"
  >
    <el-button style="margin-left: 25px;width: 80px" type="primary" @click="copy">{{ $t('CargoMsg.Cargo_OneClickCopy') }}</el-button>
    <cargo-ag-grid
      :show-side-bar="false"
      :column-defs="columnDefs"
      :row-data="rowData"
      :grid-options="gridOptions"
      style="margin-top: 15px;margin-left: 25px;margin-bottom: 15px;width: 95%;height: 252px"
      @rowDataChanged="rowDataChanged"
    />
    <span>{{ copyNote }}</span>
    <div slot="footer" style="text-align: center">
      <el-button style="width: 130px" type="primary" @click="innerVisible=false;$emit('close')">{{ $t('Message.GotIt') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'BatchSubmitOrApproveDialog',
  props: {
    // 实现方式调整、优化 CARGO-34031 2.业务费用申请模块调整方案
    // viewSource: { type: String, default: VIEW_SOURCE_APPROVAL_MATTERS.code }, // 页面请求发起方，默认【审批事项】
    isSubmit: { type: Boolean, default: () => false }, // 默认【非提交】
    rowData: { type: Array, default: () => [] },
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      dialogLabel: this.$t('CargoMsg.Cargo_ApprovalException'),
      formNumberHeaderName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
      gridOptions: {
        onSortChanged: (event) => {
          let serialNumber = 0
          const nodes = event.api.rowModel.rowsToDisplay
          nodes.forEach(node => {
            const row = this.rowData.filter(row => {
              return row.formNumber === node.data.formNumber
            })[0]
            row.serialNumber = ++serialNumber
          })
          event.api.refreshCells({ force: true })
        }
      },
      innerVisible: false,
      copyNote: this.$t('CargoMsg.Cargo_OneClickCopyNote')
    }
  },
  computed: {
    columnDefs() {
      return this.initGridColumns()
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (this.innerVisible) {
        if (this.isSubmit) {
          this.copyNote = this.$t('CargoMsg.Cargo_OneClickCopyNoteBillPaymentApply')
          this.formNumberHeaderName = this.$t('CargoMsg.Cargo_ApplicationNo')
        } else {
          this.dialogLabel = this.$t('CargoMsg.Cargo_SubmitException')
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    initGridColumns() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 25,
          sortable: false
        },
        {
          headerName: this.formNumberHeaderName,
          field: 'formNumber',
          sort: 'asc',
          width: 180
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ResultMessage'),
          field: 'errorMsg',
          width: 490
        }
      ]
    },
    // 复制到剪切板
    copy() {
      const textareaEl = document.createElement('textarea')
      // 防止手机上弹出软键盘
      textareaEl.setAttribute('readonly', 'readonly')
      let text = []
      this.rowData.forEach(row => {
        text = [...text, row.formNumber]
      })
      textareaEl.value = text.join(',')
      document.body.appendChild(textareaEl)
      textareaEl.select()
      const res = document.execCommand('copy')
      document.body.removeChild(textareaEl)
      return res
    },
    rowDataChanged(params) {
      let serialNumber = 0
      const nodes = params.api.rowModel.rowsToDisplay
      nodes.forEach(node => {
        const row = this.rowData.filter(row => {
          return row.formNumber === node.data.formNumber
        })[0]
        row.serialNumber = ++serialNumber
      })
      this.columnDefs.forEach(column => {
        delete column.colId
      })
      params.api.refreshCells({ force: true })
    }
  }
}
</script>
